import { render, staticRenderFns } from "./ShiftSetupGrid.vue?vue&type=template&id=77fec620"
import script from "./ShiftSetupGrid.vue?vue&type=script&lang=js"
export * from "./ShiftSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports